/**
 * Portal API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { observable, action, runInAction } from 'mobx';
import { inject, injectable, optional } from 'inversify';
import axios, { AxiosPromise, AxiosRequestConfig } from 'axios';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration, ErrorStatusMap, ExtraAxiosConfig } from '../configuration';


@injectable()
export class PaymentLinkApiService {

    protected basePath = '';
    protected configuration = new Configuration();

    constructor(@inject(BASE_PATH) @optional() basePath: string, @optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }


    @observable
    public isInvoicePaymentLinkExpiredObservable: boolean | undefined = undefined;

    /**
     * Return true if payment link for user in regard to invoice is expired
     * 
          */
    @action
    public isInvoicePaymentLinkExpired(showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<boolean> {

        const headers: { [index: string]: string } = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<boolean>(
            `${this.basePath}/api/paymentlink/invoicePaymentLinkExpired`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() => this.isInvoicePaymentLinkExpiredObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public isStatementPaymentLinkExpiredObservable: boolean | undefined = undefined;

    /**
     * Return true if payment link for user in regard to statement is expired
     * 
          */
    @action
    public isStatementPaymentLinkExpired(showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<boolean> {

        const headers: { [index: string]: string } = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<boolean>(
            `${this.basePath}/api/paymentlink/statementPaymentLinkExpired`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() => this.isStatementPaymentLinkExpiredObservable = response.data);
            }
            return response;
        });
    }
}
